<template>
  <div
    v-if="showAlert"
    class="Alert"
    :class="typeAlert"
  >
    <div class="Alert-Icon">
      <IconComponent
        :name="nameIcon"
        :color="colorIcon"
      />
    </div>
    <div>
      <h3
        class="Alert-Title"
        :class="typeAlert"
      >
        {{ title }}
      </h3>
      <p
        class="Alert-Text"
        :class="typeAlert"
      >
        {{ text }}
      </p>
    </div>
    <div class="Alert-Icon -Close">
      <IconComponent
        v-if="iconClose"
        name="Remove"
        :color="colorIcon"
        :handle-click="closeAlert"
      />
    </div>
  </div>
</template>
<script>
import IconComponent from '../Icon/Icon.vue';

export default {
  components: { IconComponent },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'warning', 'error', 'info'].includes(value.toLowerCase()),
    },
    iconClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showAlert: true,
    };
  },
  computed: {
    typeAlert() {
      if (this.type === 'success') {
        return '-Success';
      } if (this.type === 'error') {
        return '-Error';
      } if (this.type === 'warning') {
        return '-Warning';
      }
      return '-Info';
    },
    nameIcon() {
      if (this.type === 'success') {
        return 'Check';
      } if (this.type === 'error') {
        return 'Error';
      } if (this.type === 'warning') {
        return 'Alert';
      }
      return 'Info';
    },
    colorIcon() {
      if (this.type === 'success') {
        return 'var(--track-color-positive-darkest)';
      } if (this.type === 'error') {
        return 'var(--track-color-negative-darkest)';
      } if (this.type === 'warning') {
        return 'var(--track-color-neutral-darkest)';
      }
      return 'var(--track-color-bluegray-80)';
    },
  },
  methods: {
    closeAlert() {
      this.showAlert = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.Alert {
  display: flex;
  padding: var(--track-spacing-sm) var(--track-spacing-lg) var(--track-spacing-sm) var(--track-spacing-md);
  border-radius: var(--track-border-radius-sm);
  border-left: var(--track-border-xl) solid var(--track-color-bluegray-80);
  background: var(--track-color-bluegray-10);
  box-shadow: var(--track-shadow-lg);

  &.-Success {
    border-left: var(--track-border-xl) solid var(--track-color-positive-darkest);
    background: var( --track-color-positive-lightest);
  }

  &.-Error {
    border-left: var(--track-border-xl) solid var(--track-color-negative-darkest);
    background: var( --track-color-negative-lightest);
  }

  &.-Warning {
    border-left: var(--track-border-xl) solid var(--track-color-neutral-darkest);
    background: var( --track-color-neutral-lightest);
  }
}

.Alert-Icon {
  margin-right: var(--track-spacing-sm);

  &.-Close {
    position: absolute;
    right: 15px;
  }
}

.Alert-Title {
  color: var(--track-color-bluegray-80);
  margin: 0;
  padding-bottom: var(--track-spacing-xs);
  font-size: var(--track-font-size-sm);
  font-family: var(--track-font-family-base);
  font-weight: var(--track-font-weight-medium);
  line-height: 140%;

  &.-Success {
    color: var(--track-color-positive-darkest);
  }

  &.-Error {
    color: var(--track-color-negative-darkest);
  }

  &.-Warning {
    color: var(--track-color-neutral-darkest);
  }
}

.Alert-Text {
  color: var(--track-color-bluegray-80);
  font-size: var(--track-font-size-xs);
  margin: 0;
  font-family: var(--track-font-family-base);
  line-height: 140%;

  &.-Success {
    color: var(--track-color-positive-darkest);
  }

  &.-Error {
    color: var(--track-color-negative-darkest);
  }

  &.-Warning {
    color: var(--track-color-neutral-darkest);
  }
}
</style>
